module.exports = __webpack_public_path__ + "media/images/common-nav/free-camping/texas-afe9876f818142c4fbd43cc9518a50b6.jpg";